import {API} from "@/Composables/api";

const getAiPrompts = async (
    params: {
        include?: Array<string>;
        fields?: Array<string>;
    } = {},
) => {
    return API.get(route("admin.ai-prompts.index"), params);
};

const getAiPrompt = async (aiPrompt: string, params = {}) => {
    return API.get(route("admin.ai-prompts.show", aiPrompt), params);
};

const storeAiPrompt = async (aiPrompt, params = {}) => {
    return API.post(route("admin.ai-prompts.store"), params, aiPrompt);
};

const updateAiPrompt = async (aiPrompt, params = {}) => {
    return API.post(route("admin.ai-prompts.update", [aiPrompt.id]), params, aiPrompt, "PUT");
};

const deleteAiPrompt = async (aiPrompt: string, params = {}) => {
    return API.delete(route("admin.ai-prompts.destroy", aiPrompt), params);
};

const restoreAiPrompt = async (aiPrompt: string, params = {}) => {
    return API.post(route("admin.ai-prompts.restore", aiPrompt), params);
};

export {getAiPrompts, getAiPrompt, storeAiPrompt, updateAiPrompt, deleteAiPrompt, restoreAiPrompt};
